webpackJsonp([72667163742175],{

/***/ 1249:
/***/ (function(module, exports) {

	module.exports = {"data":{"mapsJson":{"name":"Vortoss Ruins","description":"Players can't build the heroes' hall or tech lab add-ons, but automatically get their effects.","filename":"map_vortoss_ruins.jpg","slug":"vortoss_ruins"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"vortoss_ruins","imageRegex":"/vortoss_ruins.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---map-vortoss-ruins-017c34e0e44efdd86368.js